/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';

const WISHLIST_PATH = 'wishlist';

export default function () {
    $(document).ready(function () {
        var url = window.location.href,
            mobileStickyMenu = $('.mobile-sticky-menu');

        if ($(window).width() < 1230) {
            mobileStickyMenu.addClass('active-child');
            window.menuParentActive = true;

            if (url.includes(WISHLIST_PATH)) {
                $('.bar-link-wishlist').addClass('active');
            } else if (url === window.location.origin
                || url === window.location.origin + '/'
                || url === window.location.origin + '//') {
                $('.bar-link-home').addClass('active');
            } else {
                mobileStickyMenu.removeClass('active-child');
                window.menuParentActive = false;
            }
        }
    });
}
